const Testimonial = () => {
  return (
    <>
      <h1>TESTIMONIALS</h1>
      <div class = "testimonial-item">
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do</p>
        <span>Joey Simwa</span>
      </div>
    </>
  )
}
export default Testimonial;